import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    EnrichContact as EnrichContactMutation,
    EnrichContactVariables as EnrichContactVariables,
    EnrichContactInput,
} from 'nutshell-graphql-types';

import ENRICH_CONTACT from '../mutations/enrich-contact.graphql';

export const useEnrichContact = (): {
    enrichContact: (arg1: EnrichContactInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [enrichContact, {loading, error}] = useMutation<
        EnrichContactMutation,
        EnrichContactVariables
    >(ENRICH_CONTACT);

    return {
        enrichContact: (input: EnrichContactInput) => enrichContact({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
